import { createContext, useContext, useMemo, useState } from 'react';
import { normalizeHubQuery } from './filterHubItems';

const HubSearchContext = createContext(null);

export function HubSearchProvider({ children }) {
  const [rawQuery, setRawQuery] = useState('');
  const query = normalizeHubQuery(rawQuery);
  const value = useMemo(
    () => ({ query, rawQuery, setRawQuery }),
    [query, rawQuery]
  );

  return (
    <HubSearchContext.Provider value={value}>{children}</HubSearchContext.Provider>
  );
}

export function useHubSearchQuery() {
  const ctx = useContext(HubSearchContext);
  return ctx?.query || '';
}

export function useHubSearchInput() {
  const ctx = useContext(HubSearchContext);
  const [localQuery, setLocalQuery] = useState('');
  return ctx ? [ctx.rawQuery, ctx.setRawQuery] : [localQuery, setLocalQuery];
}
